import styled from "styled-components"

import { LINK_COLOR } from "../helpers/styles"

export const StyledA = styled.a`
  color: ${LINK_COLOR};
`
